import React, {useState,useEffect} from "react";
import database from '../firebase';
import AlbumImgs from './AlbumImgs';

const db = database.firestore();
const storage = database.storage();

export default function Albums(props) {
    //const State = props.State;
    const [State, setState] = useState(props.State);
    const [ID] = useState(props.ID);
    const [ImgTitleid] = useState(props.id);

    const [Message, seMessage] = useState("haven't chosen an image");
    const [Message_, seMessage_] = useState("还未选择图片");
    const [Img, setUrls] = useState([]);
    const [length, setLength] = useState(0);
    const [Album, setAlbum] = useState([]);
    const [progress, setProgress] = useState(0);
    const [images, setImages] = useState([]);
    
    useEffect(() =>  {
        db.collection("users").doc(ID).collection("Album")
            .doc(ImgTitleid).collection("images").onSnapshot(querySnapshot=>{
                const data = querySnapshot.docs.map(doc=>doc.data());
                setAlbum(data);
                setLength(data.length);
                if (data.length ===0)setState("Delete");
                setUrls([]);
                querySnapshot.forEach(doc =>{
                    const url = doc.data().image;
                    setUrls((prevState) => [url, ...prevState]);
                })
        })
        setState("Normal")
        setProgress(0)
        setImages([])
    },[ID,ImgTitleid])

    useEffect(()=>{
        if (progress > 99.9){
            setProgress(0)
            setImages([])
        }
    },[progress]) 
    
    useEffect(()=>{
        if(images.length>0){
            seMessage("image selected")
            seMessage_("已选择图片")
        }else{
            seMessage("haven't chosen an image")
            seMessage_("还未选择图片")
        }
    },[images])


    const updateImage = (e)=>{
        setImages([]);
        for (let i=0; i<e.target.files.length; i++){
            const newImage = e.target.files[i];
            newImage["id"] = Math.random();
            setImages((prevState) => [newImage, ...prevState]);
        }
    };

    const handleUpload =(e)=>{
        e.preventDefault();

        var progress_ = 0;
        Promise.all(images.map(async(image) =>{
            await storage.ref(ID+"/Album/"+ImgTitleid+"/"+image.name).put(image).then(async()=>{

                await storage.ref(ID).child("/Album/"+ImgTitleid+"/"+image.name).getDownloadURL().then((url)=>{
                    const ref = db.collection("users").doc(ID).collection("Album").doc(ImgTitleid).collection("images").doc();
                    ref.set({
                        image: url,
                        id: ref.id,
                    })
                })
            })
            progress_ += 100/images.length;
            setProgress(progress_);
        }))
    }


    const Edit=()=>{
        setState("Edit")
        setProgress(0)
        setImages([])
    }

    const View=()=>{
        setState("View")
        setTimeout(()=>{
            setMove(true);

            //Mid
            setImgs00(Img[length-1])
            setImgs01(Img[0])
            setImgs02(Img[1])
            document.getElementById("Imgs0").style.marginLeft="-100%";
            document.getElementById("Imgs0").style.visibility="visible";
            //Left
            setImgs10(Img[length-2])
            setImgs11(Img[length-1])
            setImgs12(Img[0])
            document.getElementById("Imgs1").style.marginLeft="-200%";
            document.getElementById("Imgs1").style.visibility="hidden";
            //Right
            setImgs20(Img[0])
            setImgs21(Img[1])
            setImgs22(Img[2])
            document.getElementById("Imgs2").style.marginLeft="0%";
            document.getElementById("Imgs2").style.visibility="hidden";
        },200)
    }

    const Back=()=>{
        setState("Normal")
        setProgress(0)
        setImages([])
    }
    
    const Delete=()=>{
        for (var i=0; i<Album.length; i++){
            db.collection("users").doc(ID).collection("Album").doc(ImgTitleid)
            .collection("images").doc(Album[i].id).delete()
        }
        db.collection("users").doc(ID).collection("Album").doc(ImgTitleid).delete();
        setState("Delete");
        
    }


    //View -------------------------------------------------------------
    const [CurrentImg, setCurrentImg] = useState(1);
    const [Imgs00, setImgs00] = useState("");
    const [Imgs01, setImgs01] = useState("");
    const [Imgs02, setImgs02] = useState("");
    const [Imgs10, setImgs10] = useState("");
    const [Imgs11, setImgs11] = useState("");
    const [Imgs12, setImgs12] = useState("");
    const [Imgs20, setImgs20] = useState("");
    const [Imgs21, setImgs21] = useState("");
    const [Imgs22, setImgs22] = useState("");
    const [Mid, setMid] = useState("Imgs0");
    const [Left, setLeft] = useState("Imgs1");
    const [Right, setRight] = useState("Imgs2");
    const [Move, setMove] = useState(false);    

    const MoveLeft =()=>{
        if (Move === true){
            var Mid_ = Mid;
            var Left_ = Left;
            var Right_ = Right;

            //Mid->Right
            document.getElementById(Mid).style.marginLeft="0%";
            document.getElementById(Mid).style.visibility="hidden";
            setRight(Mid_);

            //Left->Mid
            document.getElementById(Left).style.marginLeft="-100%";
            document.getElementById(Left).style.visibility="visible";
            setMid(Left_);

            //Right->Left
            document.getElementById(Right).style.marginLeft="-200%";
            document.getElementById(Right).style.visibility="hidden";
            ChangeLeft(Right, CurrentImg);
            setLeft(Right_);

            if (CurrentImg === 1){
                setCurrentImg(Img.length)
            }else{
                var CurrentImg_ = CurrentImg;
                setCurrentImg(CurrentImg_-1);
            }

            setMove(false);
            setTimeout(()=>{
                setMove(true);
            },800)

        }
    }

    const ChangeLeft =(Id, CurrentI)=>{
        if (Id === "Imgs0"){
            if(CurrentI-1 >0){
                setImgs02(Img[CurrentI-2])
            }else{
                setImgs02(Img[Img.length-1])
            }
            if(CurrentI-2 >0){
                setImgs01(Img[CurrentI-3])
            }else{
                setImgs01(Img[Img.length+(CurrentI-2)-1])
            }
            if(CurrentI-3 >0){
                setImgs00(Img[CurrentI-4])
            }else{
                setImgs00(Img[Img.length+(CurrentI-3)-1])
            }
        }else if (Id === "Imgs1"){
            if(CurrentI-1 >0){
                setImgs12(Img[CurrentI-2])
            }else{
                setImgs12(Img[Img.length-1])
            }
            if(CurrentI-2 >0){
                setImgs11(Img[CurrentI-3])
            }else{
                setImgs11(Img[Img.length+(CurrentI-2)-1])
            }
            if(CurrentI-3 >0){
                setImgs10(Img[CurrentI-4])
            }else{
                setImgs10(Img[Img.length+(CurrentI-3)-1])
            }
        }else if (Id === "Imgs2"){
            if(CurrentI-1 >0){
                setImgs22(Img[CurrentI-2])
            }else{
                setImgs22(Img[Img.length-1])
            }
            if(CurrentI-2 >0){
                setImgs21(Img[CurrentI-3])
            }else{
                setImgs21(Img[Img.length+(CurrentI-2)-1])
            }
            if(CurrentI-3 >0){
                setImgs20(Img[CurrentI-4])
            }else{
                setImgs20(Img[Img.length+(CurrentI-3)-1])
            }
        }
    }

    const MoveRight =()=>{
        if (Move === true){
            var Mid_ = Mid;
            var Left_ = Left;
            var Right_ = Right;

            //Mid->Left
            document.getElementById(Mid).style.marginLeft="-200%";
            document.getElementById(Mid).style.visibility="hidden";
            setLeft(Mid_);

            //Left->Right
            document.getElementById(Left).style.marginLeft="0%";
            document.getElementById(Left).style.visibility="hidden";
            ChangeRight(Left, CurrentImg);
            setRight(Left_);

            //Right->Mid
            document.getElementById(Right).style.marginLeft="-100%";
            document.getElementById(Right).style.visibility="visible";
            setMid(Right_);

            if (CurrentImg === Img.length){
                setCurrentImg(1)
            }else{
                var CurrentImg_ = CurrentImg;
                setCurrentImg(CurrentImg_+1);
            }

            setMove(false);
            setTimeout(()=>{
                setMove(true);
            },800)
        }
    }

    const ChangeRight =(Id, CurrentI)=>{
        if (Id === "Imgs0"){
            if(CurrentI >=Img.length){
                setImgs00(Img[CurrentI-Img.length])
            }else{
                setImgs00(Img[CurrentI])
            }
            if(CurrentI+1 >=Img.length){
                setImgs01(Img[CurrentI+1-Img.length])
            }else{
                setImgs01(Img[CurrentI+1])
            }
            if(CurrentI+2 >=Img.length){
                setImgs02(Img[CurrentI+2-Img.length])
            }else{
                setImgs02(Img[CurrentI+2])
            }
        }else if (Id === "Imgs1"){
            if(CurrentI >=Img.length){
                setImgs10(Img[CurrentI-Img.length])
            }else{
                setImgs10(Img[CurrentI])
            }
            if(CurrentI+1 >=Img.length){
                setImgs11(Img[CurrentI+1-Img.length])
            }else{
                setImgs11(Img[CurrentI+1])
            }
            if(CurrentI+2 >=Img.length){
                setImgs12(Img[CurrentI+2-Img.length])
            }else{
                setImgs12(Img[CurrentI+2])
            }
        }else if (Id === "Imgs2"){
            if(CurrentI >=Img.length){
                setImgs20(Img[CurrentI-Img.length])
            }else{
                setImgs20(Img[CurrentI])
            }
            if(CurrentI+1 >=Img.length){
                setImgs21(Img[CurrentI+1-Img.length])
            }else{
                setImgs21(Img[CurrentI+1])
            }
            if(CurrentI+2 >=Img.length){
                setImgs22(Img[CurrentI+2-Img.length])
            }else{
                setImgs22(Img[CurrentI+2])
            }
        }
    }

    if (State === "Normal"){
        return (
        <div className="AlbumUser-create_">
            <h4>{ImgTitleid} </h4>
            <img src={Img[0]} alt=""/>
            <button onClick={Edit}>Edit <br/> 编辑</button>
            <button onClick={View}>View <br/> 浏览</button>
        </div>
        )
    }else if (State === "Edit"){
        return (
        <div className="AlbumUser-Edit">
            <h1>{ImgTitleid}</h1>
            <div className="AlbumUser-Edit-Language" onClick={Back}> <h3>Back<br/>返回</h3></div>

            <div className="AlbumUser-Edit-Update-box">
                <form onSubmit={handleUpload}>
                    <div className="AlbumUser-Edit-Update">
                    <input type="file" required onChange={updateImage}
                        multiple id="AlbumEditinputImage"></input>
                    
                    <label htmlFor="AlbumEditinputImage"><h6>Select Image <br/>选择图片</h6></label>
                    <h5>{Message}</h5> 
                    <h5>{Message_}</h5>
                    <progress value={progress} max="100"/><br/>

                    <button type="submit">Add<br/>添加</button>
                    </div>
                    <button className="AlbumUser-Edit-Delete" type="submit" onClick={Delete}><h4>Delete All !!!</h4> <h4>删除整个相册!!!</h4></button>
                </form>

                <div>
                    {Album.map(each => <AlbumImgs
                        key = {each.id}
                        id = {each.id}
                        image = {each.image}
                        title = {ImgTitleid}
                        ID = {ID}
                        Clear = {false}
                    />)}
                </div> 
            </div>
        </div>
        )
    }else if (State === "View" && length>1){
        return (
        <div className="AlbumView">
            <h1> {ImgTitleid}</h1>
            <div className="AlbumView-Language" onClick={Back}> <h3>Back<br/>返回</h3> </div>
            <div>
            <div  className="AlbumView-Imgs" id="Imgs0">
                    <img src={Imgs00} alt=""/>
                    <img src={Imgs01} alt=""/>
                    <img src={Imgs02} alt=""/>
            </div>

            <div  className="AlbumView-Imgs" id="Imgs1">
                    <img src={Imgs10} alt=""/>
                    <img src={Imgs11} alt=""/>
                    <img src={Imgs12} alt=""/>
            </div>

            <div  className="AlbumView-Imgs" id="Imgs2">
                    <img src={Imgs20} alt=""/>
                    <img src={Imgs21} alt=""/>
                    <img src={Imgs22} alt=""/>
            </div>

            <button  className="AlbumView-Left" onClick={MoveLeft}>{"<<"}</button>
            <button  className="AlbumView-Right" onClick={MoveRight}>{">>"}</button>
            </div>
        </div>
        )
    }else if (State === "View" && length===1){
        return (
            <div className="AlbumView">
                <h1> {ImgTitleid}</h1>
                <div className="AlbumView-Language" onClick={Back}> <h3>Back<br/>返回</h3> </div>
                <div>
                <div  className="AlbumView-Imgs" id="Imgs0">
                        <img src={Imgs00} alt=""/>
                        <img src={Imgs01} alt=""/>
                        <img src={Imgs02} alt=""/>
                </div>
    
                <div  className="AlbumView-Imgs" id="Imgs1">
                        <img src={Imgs10} alt=""/>
                        <img src={Imgs11} alt=""/>
                        <img src={Imgs12} alt=""/>
                </div>
    
                <div  className="AlbumView-Imgs" id="Imgs2">
                        <img src={Imgs20} alt=""/>
                        <img src={Imgs21} alt=""/>
                        <img src={Imgs22} alt=""/>
                </div>
                </div>
            </div>
            )
    }else if (State === "Delete"){
        return(
        <>
        </>
        )
    }   
    
}